/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { black } from '../styles';

var closeButtonStyle = {
  color: black,
  lineHeight: '1rem',
  fontSize: '1.5rem',
  padding: '1rem',
  cursor: 'pointer',
  position: 'absolute',
  right: 0,
  top: 0
};

function CloseButton(_ref) {
  var close = _ref.close;

  return React.createElement(
    'span',
    {
      title: 'Click or press Escape to dismiss.',
      onClick: close,
      style: closeButtonStyle
    },
    '\xD7'
  );
}

export default CloseButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-error-overlay/lib/components/CloseButton.js
// module id = ./node_modules/react-error-overlay/lib/components/CloseButton.js
// module chunks = 0